/* eslint-disable no-param-reassign */

export const accessKeyMask = (accesskey) => {
    let aux = accesskey;
    aux = aux.replace(/\D/g, '');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    aux = aux.replace(/(\d{4})(\d)/, '$1 $2');
    return aux;
};

export const normalizeName = (v) => v.toLowerCase().replace(/(?:^|\s)\S/g, (s) => s.toUpperCase());


export const getStatusBadge = (status) => {
    switch (status) {
        case "Realizada": return "success";
        case "Aguardando": return "warning";
        case "Coletando": return "primary";
        default: return "primary";
    }
}

export const translatedStatus = (status) => {
    switch (status) {
        case "NA FILA": return "Na fila";
        case "FREEZER": return "Aguardando";
        case "OK": return "Realizado";
        case "COLETANDO": return "Coletando";
        default: return status;
    }
}

export const translatedStatusAPI = (status) => {
    switch (status) {
        case "Na fila": return "NA FILA";
        case "Aguardando": return "FREEZER";
        case "Realizado": return "OK";
        case "Coletando": return "COLETANDO";
        default: return status;
    }
}

export const colorsPalette = () =>
    [
        "#00afef",
        "#7bbee9",
        "#b0cde3",
        "#dddddd",
        "#a496bc",
        "#6b549b",
        "#27157a",
        "#003f5c",
        "#bc5090",
        "#ff6361",
        "#ffa600"
    ].reverse();

export const colorsPalette2 = () =>
    [
        "#67001f",
        "#b2182b",
        "#d6604d",
        "#f4a582",
        "#fddbc7",
        "#d1e5f0",
        "#92c5de",
        "#4393c3",
        "#2166ac",
        "#053061",
        "#67001f",
        "#b2182b",
        "#d6604d",
        "#f4a582",
        "#fddbc7",
        "#d1e5f0",
        "#92c5de",
        "#4393c3",
        "#2166ac",
        "#053061",
        "#67001f",
        "#b2182b",
        "#d6604d",
        "#f4a582",
        "#fddbc7",
        "#d1e5f0",
        "#92c5de",
        "#4393c3",
        "#2166ac",
        "#053061"
    ];

export const removeSpecialCharacters2 = (name) => {
    let formatName = "";
    formatName = name.replace(/[áàãâä]/g, 'a');
    formatName = name.replace(/[éèêë&]/g, 'e');
    formatName = name.replace(/[íìîï]/g, 'i');
    formatName = name.replace(/[óòõôö]/g, 'o');
    formatName = name.replace(/[úùûü]/g, 'u');
    formatName = name.replace(/[ç]/g, 'c');
    formatName = name.replace(/[!@#$%^&*-]/g, '');
    formatName = name.replace(/[^\w\s]/gi, '');
    return formatName;
}

export const intToMoney = (value, virgula = false) => {
    if (value.toString().indexOf(".") !== -1) {
        value = value.toFixed().replace(".", "");
    } else {
        value = value.toString();
    }
    const temp = {};
    temp.cents =
        value.length !== 1
            ? value.slice(value.length - 2, value.length)
            : `0${value.slice(value.length - 2, value.length)}`;
    temp.real = value.slice(0, value.length - 2)
        ? value.slice(0, value.length - 2)
        : "0";
    return virgula ? `${temp.real},${temp.cents}` : temp;
}

export const brMoneyMask = (value) => {
    let n = intToMoney(value, true).replace(",", ".");
    n = parseFloat(n.replace(",", "."));
    const number = n.toFixed(2).split('.');
    number[0] = number[0].split(/(?=(?:...)*$)/).join('.');
    return number.join(',');
}

export const paymentPackages = {
    "7YfUqRRba": { name: "pro plus", value: "R$ 150.000", formatName: "Pro Plus" },
    "7YfUqFLev": { name: "profissional", value: "R$ 100.000", formatName: "Profissional" },
    "7YfUqvbmb": { name: "avancado", value: "R$ 80.000", formatName: "Avançado" },
    "7YfUpzHHR": { name: "intermediario", value: "R$ 40.000", formatName: "Intermediário" },
    "7YfUM7NnG": { name: "basico", value: "R$ 15.000", formatName: "Basico" },
    "7YhAH5X7G": { name: "inicial", value: "R$ 2.500", formatName: "Inicial" },
    "7YfUxCTQv": { name: "teste", value: "R$ 5,00", formatName: "Teste" },
};

export const servicesDescripton = {
    "accessKeyEnrichment": "Enriquecimento da Nota Fiscal",
    "ACCESS_KEY_ENRICHMENT": "Enriquecimento da Nota Fiscal",
    "ocrEnrichment": "Consulta através do OCR da Nota Fiscal",
    "generateImage": "Geração da Imagem da Nota Fiscal com os Dados na Nota Fiscal",
    "campaignSetup": "Criação da Campanha",
    "campaignValidation": "Campanha",
    "enabled": "enabled"
};

export const servicesDescripton2 = {
    "ACCESS_KEY_ENRICHMENT": "Enriquecimento da Nota Fiscal",
    "OCR_ENRICHMENT": "Consulta através do OCR da Nota Fiscal",
    "GENERATE_IMAGE": "Geração da Imagem da Nota Fiscal com os Dados na Nota Fiscal",
    "CAMPAIGN_SETUP": "Criação da Campanha",
    "CAMPAIGN_VALIDATION": "Campanha",
    "enabled": "enabled"
};

export const requestServicesDescripton = {
    "cpf": "Consulta de CPF",
    "image": "Consulta de OCR",
    "price": "Precificação",
    "profile": "Relátorio de Perfil",
    "reader": "Leitura De Nota",
    "serpro": "Leitura notas Censuradas",
    "validation": "Validação da campanha"
};

export const JSONA = {
    "11": { models: [], name: "RO" },
    "12": { models: [], name: "AC" },
    "13": { models: ["55", "65"], name: "AM" },
    "14": { models: [], name: "RR" },
    "15": { models: [], name: "PA" },
    "16": { models: [], name: "AP" },
    "17": { models: ["55", "65"], name: "TO" },
    "21": { models: ["55", "65"], name: "MA" },
    "22": { models: ["55", "65"], name: "PI" },
    "23": { models: [], name: "CE" },
    "24": { models: ["55", "65"], name: "RN" },
    "25": { models: ["55", "65"], name: "PB" },
    "26": { models: ["55", "65"], name: "PE" },
    "27": { models: [], name: "AL" },
    "28": { models: ["55", "65"], name: "SE" },
    "29": { models: ["55", "65"], name: "BA" },
    "31": { models: ["55", "65"], name: "MG" },
    "32": { models: ["55", "65"], name: "ES" },
    "33": { models: ["55", "65"], name: "RJ" },
    "35": { models: ["55", "59", "65"], name: "SP" },
    "41": { models: ["55", "65"], name: "PR" },
    "42": { models: ["55", "65"], name: "SC" },
    "43": { models: ["55", "65"], name: "RS" },
    "50": { models: ["55", "65"], name: "MS" },
    "51": { models: ["55", "65"], name: "MT" },
    "52": { models: ["55", "65"], name: "GO" },
    "53": { models: ["55", "65"], name: "DF" }
};

export const ShoppingCode = {
    'SAM': 'AMAZONAS',
    'BSC': 'BANGU SHOPPING',
    'BBE': 'BOULEVARD BELEM',
    'BBH': 'BOULEVARD BELO HORIZONTE',
    'BSN': 'BOULEVARD SHOPPING BAURU',
    'BFS': 'BOULEVARD SHOPPING FEIRA DE SANTANA',
    'BVC': 'BOULEVARD SHOPPING VITÓRIA DA CONQUISTA',
    'SCG': 'CAMPO GRANDE',
    'SCP': 'CAMPINAS',
    'CAS': 'CARIOCA SHOPPING',
    'CAR': 'CARIRI SHOPPING',
    'SCL': 'CATUAI LONDRINA',
    'SCM': 'CATUAI MARINGA',
    'CAX': 'CAXIAS SHOPPING',
    'SCT': 'CURITIBA',
    'SDR': 'DEL REY',
    'DEV': 'DESENVOLVIMENTO',
    'SET': 'ESTAÇAO',
    'SEB': 'ESTACAO BH',
    'SEC': 'ESTACAO CUIABA',
    'FSC': 'FRANCA SHOPPING',
    'SGO': 'GOIANIA',
    'SIC': 'IGUATEMI CAXIAS',
    'SIS': 'INDEPENDENCIA',
    'SJS': 'JARDIM SUL',
    'SLB': "LEBLON",
    'MNR': "MANAUARA SHOPPING",
    'MCL': "MONTES CLAROS SHOPPING",
    'SMO': 'MOOCA',
    'SMS': 'METRO SANTA CRUZ',
    'SNS': 'NORTE SHOPPING',
    'RCS': 'RECREIO SHOPPING',
    'PSB': "PARQUE SHOPPING BELÉM",
    'PDP': "PARQUE DOM PEDRO",
    'PDA': "PASSEIO DAS ÁGUAS SHOPPING",
    'PAS': "PASSEIO SHOPPING",
    'SPN': 'PLAZA NITEROI',
    'SPZ': 'PLAZA SUL SHOPPING',
    'SPC': 'PIRACICABA',
    'SRA': 'RIO ANIL',
    'SSB': 'SAO BERNARDO',
    'SCA': 'SHOPPING CAMPO LIMPO',
    'SDB': 'SHOPPING DA BAHIA',
    'SGR': 'SHOPPING GRANDE RIO',
    'MTR': 'SHOPPING METRÓPOLE',
    'SPG': 'SHOPPING PARANGABA',
    'PNA': 'SHOPPING PRAÇA NOVA ARAÇATUBA',
    'PNS': 'SHOPPING PRAÇA NOVA SANTA MARIA',
    'ELD': 'SHOPPING ELDORADO',
    'STA': 'TABOÃO',
    'STB': 'TAMBORÉ',
    'STJ': 'TIJUCA',
    'SUB': 'UBERLÂNDIA',
    'SVL': 'VILLA LOBOS',
    'SVV': 'VILA VELHA',
    'undefined': 'SEM REGISTRO'
}



export const inputAccessKeyMask = () =>
    [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ];